var _excluded = ["partnerName", "backgroundType", "logoType", "height", "width", "size", "aria-label", "svgProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useTheme } from 'styled-components';
// eslint-disable-next-line no-restricted-syntax
import * as logoViewBoxes from "../LogoViewBoxes";
import Container from "./styles";
var PartnerLogo = function PartnerLogo(_ref) {
  var partnerName = _ref.partnerName,
    backgroundType = _ref.backgroundType,
    _ref$logoType = _ref.logoType,
    logoType = _ref$logoType === void 0 ? 'symbol' : _ref$logoType,
    height = _ref.height,
    width = _ref.width,
    size = _ref.size,
    ariaLabel = _ref['aria-label'],
    svgProps = _ref.svgProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    mode = _useTheme.mode;
  var whichLogo = function whichLogo(type) {
    var logo = logoType && logoType !== 'symbol' ? partnerName + '-' + logoType : partnerName;
    if (type && type === 'dark') {
      return "".concat(logo, "-dark");
    } else if (type && type === 'light') {
      return logo;
    } else if (mode === 'dark') {
      return "".concat(logo, "-dark");
    } else {
      return logo;
    }
  };
  var logoViewBox = logoViewBoxes[whichLogo(backgroundType)];
  var viewBoxCoordinates = (logoViewBox === null || logoViewBox === void 0 ? void 0 : logoViewBox.split(' ')) || [];
  var defaultWidth = viewBoxCoordinates[2];
  var defaultHeight = viewBoxCoordinates[3];
  return /*#__PURE__*/React.createElement(Container //we add pixels here because view box coordinates are numbers
  , _extends({
    height: height ? height : defaultHeight + 'px',
    width: width ? width : defaultWidth + 'px',
    logoSize: size,
    className: "logo",
    role: "img",
    "aria-label": ariaLabel,
    "data-qa-logo": partnerName
  }, rest), /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo-svg",
    viewBox: logoViewBox,
    focusable: false,
    "data-qa-logo-svg": "".concat(partnerName, "-svg")
  }, svgProps), /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#sslogosvg-".concat(whichLogo(backgroundType))
  })));
};
export default PartnerLogo;